// extracted by mini-css-extract-plugin
module.exports = {"header":"_5D16g4uc","titles":"_5D1Cmc4Z","title":"_5D2NxVk1","subtitle":"_5D3PpMso","image-container":"_5D1Vb91V","image":"_5D28e53F"};